module.exports = __webpack_public_path__ + "static/img/d101.39397731.png";